import styled from "styled-components";
import { body1 } from "~/guidelines/Typography";

export const ListItem = styled.li``;

export const UnorderedList = styled.ul`
  margin: 0;
  padding: 0;
  padding-left: 20px;

  ${body1};
  list-style-type: disc;

  & ${ListItem} {
    padding-left: ${({ theme }) => theme.spacing(0)};

    &::marker {
      color: ${({ theme }) => theme.color.text.lightFirst};
      font-size: 0.7rem;
    }
  }
`;
